import {  useState } from "react";
import { Box, Button, CssBaseline, Typography } from "@mui/material";
import MetaDecorator from "../services/meta_decorator";
import { Navigate, useParams } from "react-router-dom";
import NDReferralHeader from "../components/shared/ndreferralheader";
import Footer from "../components/shared/footer";
import { blackcolor, bodyBg, darkcolor, footerContainer, fullHeight, headerText, mainGrid, pcolor, rcolor, whitecolor } from "../style2";
import BackToTop from "../components/shared/scrollTop";

export default function ReferralProceed() {
    const [redirect, setRedirect] = useState('');
    const { orgCode } = useParams();
    const referralPoint = [{ icon: "../../listitemsymbol-red.jpg", color: rcolor, text: <>Children must registered with a GP practice in Derby City, Amber Valley, Erewash, or South Derbyshire and South Dales.</> },
    { icon: "../../listitemsymbol.jpg", color: "", text: <>We accept children aged 0-16 years (up to 19 years if in special school placement).</> },
    { icon: "../../listitemsymbol.jpg", color: "", text: <>All relevant forms must be completed as incomplete referral templates will be returned to referrer for more information.</> },
    { icon: "../../listitemsymbol-red.jpg", color: rcolor, text: <>All referrals should include clearly the reason for the referral and with a clear referral question.</> },
    {
        icon: "../../listitemsymbol.jpg", color: "", text: <>For referrals into the ASD or ADHD assessment pathway with concerns causing significant impairment, please complete
            the pre-school or school concern form depending on the age of the child, parent/carer questionnaire and the
            Neurodevelopmental referral form.</>
    },
    { icon: "../../listitemsymbol-red.jpg", color: rcolor, text: <>Please note we do not accept referrals for ADHD assessment for children under 51/2 years of age.</> },
    {
        icon: "../../listitemsymbol.jpg", color: "", text: <>It is recommended that the referral is completed by the professional who best knows the child ( a minimum of 3
            months) and can evidence what support has been offered and why an assessment is needed.</>
    },
    {
        icon: "../../listitemsymbol.jpg", color: "", text: <>The referral must evidence what graduated approach to support the child/young person has been implemented over a
            minimum of 6 months.</>
    },
    {
        icon: "../../listitemsymbol.jpg", color: "", text: <>A diagnosis is not needed to access support or for reasonable adjustments to be put in place within their education
            setting. Support via the graduated response is needs led and not diagnosis dependent.
        </>
    },
    ]
    const referralrefusalpoints = [
        {
            icon: "../../listitemsymbol.jpg", color: "", text: <><strong>General behavioural issues, emotional difficulties, mild mental health issues</strong><br />
                Locally, the service that is commissioned to work with children who are suffering with mild mental health, emotional or
                behavioural difficulties is Compass.<br /><br />
                <a href="https://www.compass-uk.org/" target="_blank" rel="noreferrer">Compass | UK Charity Providing Health & Wellbeing Services</a>
            </>
        },

        {
            icon: "../../listitemsymbol.jpg", color: "", text: <><strong>For problems with educational provision or attainment, these would be better addressed by schools (through the
                Special Educational Needs Coordinator, SENCO).</strong><br /><br />
                <a rel="noreferrer" href="https://www.derbyshirehealthcareft.nhs.uk/services/childrens-mental-health-services-camhs-derby-and-southern-derbyshire" target="_blank">Children's mental health services (CAMHS) - Derby and southern Derbyshire :: Derbyshire Healthcare NHS Foundation
                    Trust</a>
            </>
        },
        {
            icon: "../../listitemsymbol.jpg", color: "", text: <><strong>For more significant concerns about a child suffering mental health difficulties, we would recommend referral to
                CAMHS.</strong> Independent advice can also be sought from Derbyshire Information
                and Advice Service for SEND (SENDIAS).
            </>
        },
        {
            icon: "../../listitemsymbol.jpg", color: "", text: <><strong>Dyslexia assessments are not undertaken by the Neurodevelopmental pathway or the Community Paediatric service.
                Such concerns should be discussed with the school.</strong> We recommend that learning difficulties in school age children,
                are evaluated by the school special education needs coordinator (SENCO) and/or educational psychologist.
            </>
        },
    ]
    const usefulLinks = [{
        icon: "../../listitemsymbol.jpg", color: "", text: <>
            <strong><a rel="noreferrer" href="https://derbyandderbyshireemotionalhealthandwellbeing.uk/" target="_blank">Derby & Derbyshire - Emotional Health & Wellbeing</a></strong><Box pt={1} pb={1}>
                This signposting service is aimed at professionals, members of the public and children and young people who wish to
                access local services or just require further information on the services that are available to them both locally and
                nationally. </Box><Box pb={1}>
                The four elements of the website focus on Children and Young People, Adults, Suicide Prevention and Neurodiversity.
                The website has information about the <a rel="noreferrer" href="https://derbyandderbyshireemotionalhealthandwellbeing.uk/neurodiversity/neurodiverse-community-hubs-support-for-0-25-years" target="_blank">community drop-in hubs for neurodiverse children and young people</a>, and their
                families and carers.</Box>
        </>
    },
    {
        icon: "../../listitemsymbol.jpg", color: "", text: <>
            <strong><a rel="noreferrer" href="https://www.derby.gov.uk/education-and-learning/derbys-send-local-offer/" target="_blank"> Derby's SEND Local Offer - Derby City Council, Home - Derbyshire Local Offer</a></strong>
            <Box pb={1} pt={1}>
                A hub of information and advice for children and young people from 0 to 25 with special educational needs and
                disabilities (SEND) and their families available in Derby City and Derbyshire.</Box>
        </>
    },
    {
        icon: "../../listitemsymbol.jpg", color: "", text: <>
            <Box sx={{ color: rcolor }}>SENDIAS (SEND Information advice and support service) can provide free, impartial and confidential information,
                advice and support to Children and Young People with special educational needs and disabilities as well as their
                Parents and Carers.</Box>
            <Box pb={1} pt={1}>
                <strong>Derby City SENDIAS</strong> -
                <a rel="noreferrer" href="https://derbysendiass.org.uk/" target="_blank">Derby SEND | Information & Advice Support Service (SENDIASS)</a>
            </Box>
            <Box pt={1}>
                <strong>Derbyshire SENDIAS</strong> - <a rel="noreferrer" href="https://www.derbyshireiass.co.uk/home.aspx" target="_blank">Welcome to the Derbyshire Information, Advice and Support Service for SEND - Derbyshire
                    Information, Advice & Support Service for SEND
                </a>
            </Box>
        </>
    },
    ]

    // useEffect(() => {
    //     const authTokens = localStorage.getItem("authTokens");
    //     let token;

    //     if (authTokens) {
    //         const parsedAuthTokens = JSON.parse(authTokens);
    //         token = parsedAuthTokens?.accessToken;
    //     }
    //     if (!token) {
    //         localStorage.clear();
    //         setRedirect(`/login/${orgCode}`);
    //         return;
    //     }
    //     fetch(getApiUrl() + "/ReferrerAccount/istokenvalid", {
    //         method: "get",
    //         headers: {
    //             'Content-Type': 'application/json',
    //             Authorization: `Bearer ${token}`
    //         },

    //     }).then(resp => {
    //         if (resp.status === 401 || resp.status === 403) {
    //             localStorage.clear();
    //             setRedirect(`/login/${orgCode}`);
    //         }
    //     }).catch(err => {
    //         console.log(err);
    //     });
    // }, [])

    if (redirect !== "")
        return <Navigate to={redirect} />
    else {
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Referral"} description={"EnrichMycare Refferal"} />
            <NDReferralHeader orgCode={orgCode} logo="../../logo.jpg" />
            <Box pt={1} sx={{ ...bodyBg, marginTop: "5px" }} p={5}>
                <Typography variant="h5" sx={{ ...headerText, margin: "10px 0px", fontSize: "2rem" }}>
                    Welcome to our online referral system
                </Typography>
                <Box sx={{ ...mainGrid, background: whitecolor }}>
                    <Typography variant="h5" sx={{ fontWeight: "bold", color: pcolor, marginBottom: "10px" }}>Referral Information</Typography>
                    {referralPoint.map((item, index) => {
                        return <Box key={index} sx={{ display: "flex", paddingY: 1 }}>
                            <img src={item.icon} style={{ height: 29, width: 32, paddingRight: 10 }} alt='' />
                            <Typography sx={{ fontSize: "1.2rem", fontWeight: "bolder", color: item.color !== "" ? item.color : darkcolor }}>
                                {item.text}
                            </Typography>
                        </Box>;
                    })}
                </Box>
                <Box sx={{ ...mainGrid, background: whitecolor, marginTop: "20px" }}>
                    <Typography variant="h5" style={{ fontWeight: "bold", color: pcolor, marginBottom: "10px" }}>We do not accept referrals for the following</Typography>
                    {referralrefusalpoints.map((item, index) => {
                        return <Box key={index} sx={{ display: "flex", paddingY: 1 }}><img src={item.icon} style={{ height: 29, width: 32, paddingRight: 10 }} alt='' />
                            <Typography style={{ fontSize: "1.2rem", color: item.color !== "" ? item.color : blackcolor }}>
                                {item.text}
                            </Typography>
                        </Box>;
                    })}
                </Box>
                <Box sx={{ ...mainGrid, background: whitecolor, marginTop: "20px" }}>
                    <Typography variant="h5" style={{ fontWeight: "bold", color: pcolor, marginBottom: "10px" }}>Useful links</Typography>
                    {usefulLinks.map((item, index) => {
                        return <Box key={index} sx={{ display: "flex", paddingY: 1 }}><img src={item.icon} style={{ height: 29, width: 32, paddingRight: 10 }} alt='' />
                            <Typography style={{ fontSize: "1.2rem", color: item.color !== "" ? item.color : blackcolor }}>
                                {item.text}
                            </Typography>
                        </Box>;
                    })}
                    <Box sx={{ color: rcolor, fontSize: "1.2rem" }} pb={3} pt={3}>
                        <strong>Safeguarding concerns</strong><br />
                        <Box py={1}>If there are safeguarding concerns please contact</Box>
                        <Box pb={1}>County (Starting point) 01629533190</Box>
                        City (first contact)- 01332641172<br /><br />
                        <strong>Early help assessment</strong><br />
                        <Box py={1}>Emerging or low-level needs may be met by universal services or other appropriate services. Agencies that identify</Box>
                        emerging needs of a child and their family should complete an early help assessment referral.
                    </Box>
                </Box>
                <Box sx={{ ...mainGrid, background: whitecolor, marginTop: "20px" }}>
                    <Typography variant="h5" style={{ fontWeight: "bold", color: pcolor, marginBottom: "10px" }}>All referrals must be submitted using this referral platform</Typography>
                    <Box sx={{ display: "flex", paddingY: 1, pb: 2 }}>
                        <img src="../../listitemsymbol-red.jpg" style={{ height: 29, width: 32, paddingRight: 10 }} alt='' />
                        <Typography style={{ fontSize: "1.2rem", color: blackcolor, fontStyle: "italic" }}>
                            JUCD Neurodevelopmental - Single Point of Access Multi-Agency Referral Form
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", paddingY: 1, pb: 2 }}>
                        <img src="../../listitemsymbol-red.jpg" style={{ height: 29, width: 32, paddingRight: 10 }} alt='' />
                        <Typography style={{ fontSize: "1.2rem", color: blackcolor, fontStyle: "italic" }}>
                            JUCD Neurodevelopmental Pathway: Pre-school Questionnaire
                        </Typography>
                    </Box>
                    <Box>OR</Box>
                    <Box sx={{ display: "flex", paddingY: 1, pb: 2 }}>
                        <img src="../../listitemsymbol-red.jpg" style={{ height: 29, width: 32, paddingRight: 10 }} alt='' />
                        <Typography style={{ fontSize: "1.2rem", color: blackcolor, fontStyle: "italic" }}>
                            JUCD Neurodevelopmental Pathway: Child Young Persons School Questionnaire
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", paddingY: 1, pb: 2 }}>
                        <img src="../../listitemsymbol-red.jpg" style={{ height: 29, width: 32, paddingRight: 10 }} alt='' />
                        <Typography style={{ fontSize: "1.2rem", color: blackcolor, fontStyle: "italic" }}>
                            JUCD Neurodevelopmental Pathway Parent/Carer Questionnaire
                        </Typography>
                    </Box>
                </Box>
                <Box py={3} textAlign="center">
                    <Button onClick={() => { setRedirect(`/whoareyou/${orgCode}`) }}
                        style={{ border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, fontSize: "1.5rem", height: "50px", width: "300px", borderRadius: 2 }}>Proceed</Button>
                </Box>
                <BackToTop />
            </Box>
            <Box sx={{ ...footerContainer, position: "static" }}>
                <Footer />
            </Box>
        </Box>;
    }
}